import { render, staticRenderFns } from "./CellRendererDepartment.vue?vue&type=template&id=bec44480&"
import script from "./CellRendererDepartment.vue?vue&type=script&lang=js&"
export * from "./CellRendererDepartment.vue?vue&type=script&lang=js&"
import style0 from "./CellRendererDepartment.vue?vue&type=style&index=0&id=bec44480&prod&lang=scss&scpoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports